import { print } from "../../servicos/Uteis"

const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent)

function getWhatsAppUrl(telLimpo, mensagem = null) {
	const base = `https://wa.me/${telLimpo}`
	return mensagem ? `${base}?text=${encodeURIComponent(mensagem)}` : base
}

function abrirLink(url) {
	if (window.AndroidInterface && typeof window.AndroidInterface.redirectLink === "function") {
		window.AndroidInterface.redirectLink(url)
	} else if (isIOS && window.webkit?.messageHandlers?.redirectLink) {
		window.webkit.messageHandlers.redirectLink.postMessage(url)
	} else {
		window.location.href = url
	}
}

export function chamarTel(tel) {
	if (tel != '-' && tel.length > 0) {
		const telLimpo = tel.replace(/\D/g, '')
		if (window.AndroidInterface && typeof window.AndroidInterface.redirectLink === "function") {
			window.AndroidInterface.redirectLink(`https://mappsistemas.com.br/ligar.php?tel=${telLimpo}`)
		} else {
			window.location.href = `tel:${telLimpo}`
		}
	} else print("telefone indisponível")
}

export function chamarWhats(tel) {
	if (tel != '-' && tel.length > 0) {
		const telLimpo = tel.replace(/\D/g, '')
		const url = getWhatsAppUrl(telLimpo)
		abrirLink(url)
	} else print("telefone indisponível")
}

export function chamarWhatsComMsg(tel, msg, idProf, nome) {

	function validarTelefone(telLimpo) {
		const regexTelefone = /^[1-9]\d{10,14}$/;
		return regexTelefone.test(telLimpo);
	}

	const telLimpo = tel.replace(/\D/g, '')
	const mensagem = `Meu nome é ${nome}.\nMeu codigo de profissional é ${idProf}.\n${msg}`;

	if (validarTelefone(telLimpo) && msg.trim().length > 0) {
		const url = getWhatsAppUrl(telLimpo, mensagem)
		abrirLink(url)
	} else print("Telefone ou mensagem inválidos")
}
